enum NotarizationStatus {
  pending = "pending",
  success = "success",
  error = "error",
}

export type Notarization = {
  id: string;
  name: string;
  date: number;
  hash: string;
  signature: string;
  status: NotarizationStatus;
  merkleRoot: string;
  merkleTreeURI?: string;
  auditId?: string;
  description?: string;
  notes?: string;
  tags?: string[];
  ipfsUri?: string;
  externalUrl?: string;
  receiptId?: string;
  verified?: boolean;
  userId: string;
  folderId: string;
  storageType?: string;
};
